import { createTheme } from "@mui/material";

export const theme = createTheme({
  typography: {
    fontFamily: ["Quicksand"].join(","),
    fontSize: 14,
    fontWeightLight: 400,
    fontWeightMedium: 500,
    fontWeightRegular: 600,
    fontWeightBold: 700,
  },
});
